import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import OptionsRouter from "../components/options";
import AccountRestrictedModal from "../components/AccountRestrictedModal";
import MaintenanceModalCommon from "../components/MaintenanceModalCommon";

const OptionsMain = () => {
  return (
    <Router>
      <OptionsRouter />
      <AccountRestrictedModal isFromBrowser={true} />
      <MaintenanceModalCommon isFromBrowser={true} />
    </Router>
  );
};

export default OptionsMain;
